import React from 'react';
import { Select, SelectMulti, ISelectMultiOption, ISelectOption } from '@salecycle/ui-component-library';
import { IClients } from '../../../../../entities';
import { useTranslation } from 'react-i18next';
import { useNewUserDispatch, useNewUserState } from '../../../context/useNewUserContext';
import { getGroupOptions, getMultiSiteOptions } from 'sections/user-management/utils/helpers';

export interface IProps {
  clients: IClients;
}

export const MultiSiteAccessLevel: React.FC<IProps> = ({ clients }: IProps) => {
  const { t } = useTranslation();
  const { user } = useNewUserState();
  const dispatch = useNewUserDispatch();
  const groupOptions = getGroupOptions(clients);
  const multiSiteOptions = getMultiSiteOptions(clients, user.selectedMultiSiteGroup?.value);

  const handleGroupChange = (selectedOption: ISelectOption<string>) => {
    dispatch({
      type: 'SET_SELECTED_GROUP_VALUE',
      payload: { selectedMultiSiteGroup: selectedOption },
    });
  };

  const handleSitesChange = (selectedOptions: ISelectMultiOption<string>[]) => {
    dispatch({
      type: 'SET_SELECTED_MULTISITE_VALUE',
      payload: { selectedMultiSites: selectedOptions },
    });
  };

  return (
    <>
      <Select
        ariaLabel={t('newUser.levels.group')}
        label={t('newUser.levels.group')}
        inputId="GroupSelect"
        onChange={handleGroupChange}
        options={groupOptions}
        value={user.selectedMultiSiteGroup}
        clearable={true}
        minLength={3}
        minLengthPlaceholder={t('common.minLengthPlaceholder', {
          minLength: 3,
        })}
        noOptionsPlaceholder={t('common.noOptionsPlaceholder')}
      />

      {user.selectedMultiSiteGroup && (
        <SelectMulti
          ariaLabel={t('newUser.levels.site_plural')}
          label={t('newUser.levels.site_plural')}
          inputId="MultiSiteSelect"
          onChange={handleSitesChange}
          options={multiSiteOptions}
          value={user.selectedMultiSites}
          clearable={true}
          noOptionsPlaceholder={t('common.noOptionsPlaceholder')}
        />
      )}
    </>
  );
};
